import React from 'react';
import apiCalls from '../PowerShadesAPIFunctions';
import { isFailedApiCall } from '../psUtil';
import PSAwningsTable from './PSAwningsTable';
import { useQuoteAwnings } from '../Store/entities/awnings/hooks';
import {
	normalizeAwningFabrics,
	normalizeAwningProperties,
} from './awningConfiguratorUtils';
import type { AwningFabric, AwningProperty } from './awningTypes';
import type { fakeRootType } from '../FakeRootType';

type PSAwningsTableContainerProps = {
	quoteId: number;
	ROOT: fakeRootType;
	unlockQuoteForEditing: () => void;
};

const PSAwningsTableContainer = ({
	quoteId,
	ROOT,
	unlockQuoteForEditing,
}: PSAwningsTableContainerProps) => {
	const quoteAwnings = useQuoteAwnings(quoteId);
	const [awningProperties, setAwningProperties] = React.useState<AwningProperty[]>([]);
	const [awningFabrics, setAwningFabrics] = React.useState<AwningFabric[]>([]);
	const [catalogLoaded, setCatalogLoaded] = React.useState(false);

	React.useEffect(() => {
		const loadCatalog = async () => {
			try {
				const [optionsResp, fabricsResp] = await Promise.all([
					apiCalls.getAwningOptions(),
					apiCalls.getAwningFabrics(),
				]);

				if (!isFailedApiCall(optionsResp)) {
					setAwningProperties(normalizeAwningProperties(optionsResp.data));
				}
				if (!isFailedApiCall(fabricsResp)) {
					setAwningFabrics(normalizeAwningFabrics(fabricsResp.data));
				}
			} finally {
				setCatalogLoaded(true);
			}
		};

		loadCatalog();
	}, []);

	if (quoteAwnings.length === 0) {
		return null;
	}

	if (!catalogLoaded) {
		return null;
	}

	return (
		<PSAwningsTable
			quoteId={quoteId}
			ROOT={ROOT}
			unlockQuoteForEditing={unlockQuoteForEditing}
			awningProperties={awningProperties}
			awningFabrics={awningFabrics}
		/>
	);
};

export default PSAwningsTableContainer;
